/**
 * Admin Authentication API Service
 * Handles login and logout requests to the backend
 */
import config from "../config";
const API_BASE_URL = config.API_BASE_URL || "http://localhost:8000";

/**
 * Login admin user
 * @param {string} email - Admin email
 * @param {string} password - Admin password
 * @returns {Promise<Object>} - Response with token and user data
 */
export const loginAdmin = async (email, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    const data = await response.json();

    // Check if login was successful
    if (!response.ok || !data.success) {
      throw new Error(data.message || "Login failed");
    }

    // Return the data object which contains token and user info
    return {
      token: data.data.token,
      admin_user_id: data.data.admin_user_id,
      email_id: data.data.email,
      first_name: data.data.first_name,
      last_name: data.data.last_name,
      user_name: data.data.user_name,
      role: data.data.role,
      profile_picture: data.data.profile_picture,
    };
  } catch (error) {
    console.error("[AUTH] Login error:", error);
    throw error;
  }
};

/**
 * Logout admin user
 * @param {string} token - JWT token
 * @returns {Promise<Object>} - Logout response
 */
export const logoutAdmin = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/admin/auth/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Logout failed");
    }

    return await response.json();
  } catch (error) {
    console.error("[AUTH] Logout error:", error);
    throw error;
  }
};

